/**
 * Opens a new window for OAuth for the given app name.
 */
export function openOAuthWindow(appName) {
  const width = 600;
  const height = 790;
  const {
    screenY,
    screenX,
    outerHeight,
    outerWidth
  } = window;

  // calculate top and left in order to center the window on the users' screen
  const top = Math.round(screenY + Math.max(0, Math.floor(outerHeight - height) / 2));
  const left = Math.round(screenX + Math.max(0, Math.floor(outerWidth - width) / 2));
  const isLinkedin = appName.toLowerCase().includes('linkedin');

  // See https://stackoverflow.com/questions/33362773/open-window-inside-promise
  // For usability and security reasons window.open() can only be called from a direct user action (during the same event loop processing that was started by a user action or within a short time afterwards from some user action).
  // If a caller wants to use oauthor generated state, we need to fetch the state first.
  // Hence this work-around:
  //   1) we open open the window synchronously when the user clicks
  //   2) we set the location when the request resolves

  return isLinkedin ?
  // See https://git.hubteam.com/HubSpot/UnifiedAuth-Tasks/issues/226.
  // LinkedIn has an extra step inside the consent screen which is not responsive. Users need to horizontally scroll in the popup. Per LinkedIn's request, we are opening the popup in a new tab.
  window.open() :
  // Regular popup experience. Why a popup?
  //  - Consistency with other third-party authentication screens inside HubSpot
  //  - Opening a new tab can also disrupt the user's workflow, causing confusion or loss of context.
  window.open('about:blank', '_blank', `menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,titlebar=no,toolbar=no,width=${width},height=${height},top=${top},left=${left}`);
}